/* 
Pantalla completamente informativa, con cuadros de texto
 */


import React, { useEffect } from "react";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "30px",
    display: "flex"
  },
  textJustifyXS: {
    [theme.breakpoints.down("sm")]: {
      textAlign: "justify"
    },
    [theme.breakpoints.up("md")]: {
      textAlign: "start"
    }
  },
  link: {
    color: "#DF7D44"
  }
}));
//#endregion

export default function FrequentQuestion(props) {
  const classes = useStyles();

  useEffect(() => {
    //Move camera top
    const comp = document.querySelector("#root").offsetTop - 100;
    window.scroll({ behavior: "smooth", top: comp });
  }, []);

  return (
    <div className={classes.root}>
      <Grid container spacing={2} justify="center" alignItems="center">
        <Fade in={true} timeout={1000}>
          <Grid
            container
            justify="center"
            alignItems="center"
            item
            xs={12}
          /* style={{ ...(values.showRegister ? { display: "none" } : {}) }} */
          >
            <Grid item xs={12}>
              <Box textAlign="center">
                <Typography color="secondary" variant="h4" data-lang="faq_title">
                  Dudas
                </Typography>
              </Box>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="flex-start"
              item
              xs={11}
              lg={9}
              className="mt-3"
            /* style={{ ...(values.showRegister ? { display: "none" } : {}) }} */
            >
              <Grid item xs={12}>
                <Typography color="primary" variant="h6" data-lang-html="faq_q1">
                  1.- ¿Cómo puedo darme de alta en el Ilusiona Club?
                </Typography>
                <Box className={classes.textJustifyXS}>
                  <p data-lang-html="faq_a1">
                    Es muy fácil, tan sólo tienes que darle de alta en nuestra
                    web <a href="https://www.ilusiona.com/club-ilusiona/" className={classes.link}>www.ilusiona.com/club-ilusiona/</a>{" "}
                    y realizar el proceso de alta. Recuerda que tienes que ser
                    mayor de 18 años.
                  </p>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography color="primary" variant="h6" data-lang-html="faq_q2">
                  2.- ¿Dónde puedo utilizar la tarjeta del Ilusiona Club?
                </Typography>
                <Box className={classes.textJustifyXS}>
                  <p data-lang-html="faq_a2">
                    Puedes usarla en todos los centros de Ilusiona, mira aquí{" "}
                    <a href="https://www.ilusiona.com/#centros" className={classes.link}>
                      www.ilusiona.com/#centros
                    </a>
                  </p>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography color="primary" variant="h6" data-lang-html="faq_q3">
                  3.- ¿Cómo recibiré mis promociones?
                </Typography>
                <Box className={classes.textJustifyXS}>
                  <p data-lang-html="faq_a3">
                    Te llegarán directamente vía email o sms, y también las
                    tendrás expuestas en nuestros centros Ilusiona.
                  </p>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography color="primary" variant="h6" data-lang-html="faq_q4">
                  4.- ¿Puedo utilizar mis promociones en otro centro distinto?
                </Typography>
                <Box className={classes.textJustifyXS}>
                  <p data-lang-html="faq_a4">
                    Los cupones o promociones podrán ser utilizados en todos
                    nuestros centros, salvo en caso que se especifique lo
                    contrario en el cupón promocional.
                  </p>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography color="primary" variant="h6" data-lang-html="faq_q5">
                  5.- ¿Y si quiero actualizar mis datos o cambiar mi email?
                </Typography>
                <Box className={classes.textJustifyXS}>
                  <p data-lang-html="faq_a5">
                    Muy fácil, puedes hacerlo tú mismo en el apartado de “Mis
                    datos” una vez entres en la web del Ilusiona Club y te
                    identifiques.
                  </p>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography color="primary" variant="h6" data-lang-html="faq_q6">
                  6.- Si tengo alguna duda, ¿cómo puedo informarme?
                </Typography>
                <Box className={classes.textJustifyXS}>
                  <p data-lang-html="faq_a6">
                    Si estás en uno de nuestros centros pregunta directamente al
                    personal de recepción. También te informaremos en{" "}
                    <a href="mailto:ilusiona.club@ilusiona.com" className={classes.link}>
                      ilusiona.club@ilusiona.com
                    </a>
                  </p>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography color="primary" variant="h6" data-lang-html="faq_q7">
                  7.- ¿Pueden canjear otras personas mis promociones?
                </Typography>
                <Box className={classes.textJustifyXS}>
                  <p data-lang-html="faq_a7">
                    Tus promociones son tuyas y sólo tuyas!. Sólo las puedes
                    canjear tú.
                  </p>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography color="primary" variant="h6" data-lang-html="faq_q8">
                  8.- ¿Puedo utilizar mis promociones más de una vez?
                </Typography>
                <Box className={classes.textJustifyXS}>
                  <p data-lang-html="faq_a8">
                    Depende. Hay muchas promociones y muy distintas. Saldrás de
                    dudas leyendo las condiciones de cada una.
                  </p>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography color="primary" variant="h6" data-lang-html="faq_q9">
                  9.- ¿Se pueden utilizar varias promociones en una misma
                  visita?
                </Typography>
                <Box className={classes.textJustifyXS}>
                  <p data-lang-html="faq_a9">
                    En general, hay que elegir una promoción por visita. Pero
                    también hay promociones acumulables. Lo verás en las
                    condiciones de uso de cada una.
                  </p>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography color="primary" variant="h6" data-lang-html="faq_q10">
                  10.- ¿En qué servicios puedo utilizar la tarjeta?
                </Typography>
                <Box className={classes.textJustifyXS}>
                  <p data-lang-html="faq_a10">
                    En todos tus servicios tanto de bar, cumpleaños como bolera.
                    Recuerda guardar los tickets de compra y mostrarlos en
                    recepción con tú tarjeta para acumular más puntos que
                    cambiar por regalos.
                  </p>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Fade>
      </Grid>
    </div>
  );
}
